import { render, staticRenderFns } from "./frist.vue?vue&type=template&id=78f0a6ff&scoped=true&"
import script from "./frist.vue?vue&type=script&lang=js&"
export * from "./frist.vue?vue&type=script&lang=js&"
import style0 from "./frist.vue?vue&type=style&index=0&id=78f0a6ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0a6ff",
  null
  
)

export default component.exports